import {Component, Input, OnInit} from "@angular/core";
import {StateService} from "@tva/ng-migration/core/services/state/state.service";

@Component({
  selector: "app-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrls: ["./user-menu.component.scss"],
})
export class UserMenuComponent implements OnInit {
  @Input() role: string;
  @Input() username: string;

  constructor(private state: StateService) {}

  ngOnInit(): void {}

  logout(): void {
    this.state.go('logout');
  }
}
